/* Fransk katalog for locale-autopilot-sales.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'ap.agent.sales.title': 'Factures et devis',
  'ap.agent.sales.pending': '{{count}} documents n\'ont pas été envoyés.',
  'ap.agent.sales.detail': 'Envoyez les factures et devis finalisés. Les brouillons doivent être finalisés dans la liste des factures.',
  'ap.agent.sales.draft': 'Brouillon',
  'ap.agent.sales.invoices': 'Factures',
  'ap.agent.sales.drafts': 'Brouillons',
  'ap.agent.sales.offers': 'Devis',
  'ap.agent.offer.sendSelected': 'Envoyer {{count}} devis sélectionnés',
  'ap.agent.sales.sentCount': '{{count}} devis envoyés',
  'ap.agent.sales.send': 'Envoyer',
  'ap.agent.sales.open': 'Ouvrir',
  'ap.agent.sales.empty': 'Aucun document non envoyé dans cette liste.',
  'ap.agent.sales.unavailable': 'Le document ne peut pas être envoyé. Ouvrez la liste des factures pour vérifier son statut.',
  'ap.agent.sales.emailMissing': 'Le client n\'a pas d\'adresse e-mail. Ajoutez-la dans la liste des factures avant l\'envoi.',
  'ap.agent.sales.sendFailed': 'Le document n\'a pas été envoyé. Réessayez depuis la liste des factures.',
});
